import API from 'services/api'
export default class Students extends API {
	async getStudents({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		filter,
	}) {
		onStart()
		const { page, page_size, search } = filter
		try {
			const options = {
				url: `/admin/student/
				${page ? `?page=${page}` : ''}
				${page_size ? `&page_size=${page_size}` : ''}
				${search ? `&search=${search}` : ''}`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async createStudents({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		try {
			const options = {
				method: 'POST',
				url: `/admin/student/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async updateStudents({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		data,
	}) {
		onStart()
		const { id } = data
		try {
			const options = {
				method: 'PUT',
				url: `/admin/student/${id}/`,
				data,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async deleteStudents({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		id,
	}) {
		onStart()
		try {
			const options = {
				method: 'DELETE',
				url: `/admin/student/${id}/`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
}
